export function toObject(obj: any): any {
  if (Object(obj) !== obj) {
    return obj;
  } else if (Array.isArray(obj)) {
    return obj.map(toObject);
  } else if (obj instanceof Map) {
    return toObject(Object.fromEntries(obj));
  }
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, toObject(v)]));
}
